import { render, staticRenderFns } from "./OtpButton.vue?vue&type=template&id=4585c7b9&"
import script from "./OtpButton.vue?vue&type=script&lang=js&"
export * from "./OtpButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports